(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sword-carrusel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sword-product-carousel')) {
  customElements.define('sword-product-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.sword-products__wrap');
      this.toggle = this.querySelector('[data-carousel-toggle]');
      if (!this.track || !this.toggle) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.hovered = false;
      this.visible = false;
      this.lastInteraction = 0;
      this.toggle.hidden = false;
      this.updateLabel();
      this.toggle.addEventListener('click', () => {
        this.paused = !this.paused;
        this.updateLabel();
      }, options);
      this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') this.hovered = true; }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; }, options);
      this.addEventListener('pointerdown', () => { this.lastInteraction = Date.now(); }, options);
      this.addEventListener('wheel', () => { this.lastInteraction = Date.now(); }, options);
      this.motion.addEventListener('change', () => {
        this.paused = this.motion.matches;
        this.updateLabel();
      }, options);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; }, { threshold: 0.2 });
      this.observer.observe(this);
      this.timer = setInterval(() => {
        if (!this.isConnected || this.paused || this.hovered || !this.visible || document.hidden || this.contains(document.activeElement) || Date.now() - this.lastInteraction < 6000) return;
        const track = this.track;
        const cards = Array.from(track.children);
        if (cards.length < 2 || track.scrollWidth <= track.clientWidth + 2) return;
        const left = track.scrollLeft;
        const next = cards.find(card => card.offsetLeft - cards[0].offsetLeft > left + 4);
        const end = left >= track.scrollWidth - track.clientWidth - 4;
        track.scrollTo({ left: end || !next ? 0 : next.offsetLeft - cards[0].offsetLeft, behavior: this.motion.matches ? 'auto' : 'smooth' });
      }, Number(this.dataset.interval) * 1000 || 4000);
    }
    updateLabel() {
      this.toggle.textContent = this.paused ? this.dataset.play : this.dataset.pause;
      this.toggle.setAttribute('aria-pressed', String(this.paused));
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.abort?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
